const joinClasses = (array) => {
    const result = array.join(' ')

    return result
}

export default joinClasses
